export default __webpack_public_path__ + "static/media/customized.66a48bb0.svg";